import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import {
    normalizeToolbarEndDate,
    normalizeToolbarStartDate,
} from './reportDateDefaults';
import { getAppTimezone } from './timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

/** Strip MaterialTable internal row state so it is not stored in React state. */
export const sanitizeEventRow = row => {
    if (!row || typeof row !== 'object') {
        return row;
    }
    const { tableData, ...rest } = row;
    return rest;
};

export const sanitizeEventRows = rows =>
    Array.isArray(rows) ? rows.map(sanitizeEventRow) : [];

/** Build a table row after create (API returns raw entry without joins). */
export const buildEventRowFromCreate = ({ created, user, device }) =>
    sanitizeEventRow({
        id: created.id,
        user_id: created.user_id,
        sap: (user && user.sap) || created.user_id,
        employee_name: (user && user.name) || '',
        genuine: created.genuine,
        time: created.time,
        event: created.event,
        device_mac: created.device_mac,
        device_name: (device && device.name) || '',
        location_name: (user && user.loc_name) || '',
        sub_loc_name: (user && user.sub_loc_name) || '',
        location: created.location,
    });

export const isEventInDateRange = (eventTime, startDate, endDate) => {
    if (!eventTime) {
        return false;
    }
    if (!startDate || !endDate) {
        return true;
    }
    const tz = getAppTimezone();
    const t = dayjs(eventTime).tz(tz);
    const start = normalizeToolbarStartDate(startDate);
    const end = normalizeToolbarEndDate(endDate);
    return (
        (t.isAfter(start) || t.isSame(start)) &&
        (t.isBefore(end) || t.isSame(end))
    );
};
